import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import styled from "styled-components";
import Box from "./Box";
var Container = styled(Box).attrs(function(_param) {
    var theme = _param.theme, maxWidth = _param.maxWidth, _$styles = _param.$styles, $styles = _$styles === void 0 ? {} : _$styles, restProps = _object_without_properties(_param, [
        "theme",
        "maxWidth",
        "$styles"
    ]);
    return _object_spread({
        $mx: "auto",
        $px: [
            20,
            null,
            null,
            null
        ],
        $styles: _object_spread({
            maxWidth: maxWidth || theme.layout.defaultContainerWidth
        }, $styles)
    }, restProps);
})({});
export default Container;
